<template>
    <div class="home">
        <b-img class="mb-3" src="images/bild.png" fluid />
        <span v-html="$t('presentation.procurement')" />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'einkauf',
        data() {
            return {};
        },
        computed: {
            ...mapGetters({
                auth: 'auth/auth'
            })
        }
    }
</script>